module.exports = __webpack_public_path__ + "static/media/SFiOBOA_nn_sekundærlogo_sentrert_pos.02f9753d.svg";